<template>
  <CarouselSection class="bg-wh"/>  
</template>

<script>
import CarouselSection from './CarouselSection.vue';

export default {
  name: 'WorkSection',
  components: {
    CarouselSection
  },
  props: {
    
  },
  data() {
    return {
      currentIndex: 0,
      autoSlideInterval: null,
    }
  },
  computed: {
      slides(){        
        return this.$tm('work.slides');
      }
  },
  mounted() {
    this.startAutoSlide();
  },
  beforeUnmount() {
    this.clearAutoSlide();
  },
  methods: {
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
      this.resetAutoSlide();
    },
    
    prevSlide() {
      this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      this.resetAutoSlide();
    },
    
    goToSlide(index) {
      this.currentIndex = index;
      this.resetAutoSlide();
    },
    
    startAutoSlide() {
      this.autoSlideInterval = setInterval(() => {
        this.nextSlide();
      }, 5000);
    },
    
    resetAutoSlide() {
      this.clearAutoSlide();
      this.startAutoSlide();
    },
    
    clearAutoSlide() {
      if (this.autoSlideInterval) {
        clearInterval(this.autoSlideInterval);
        this.autoSlideInterval = null;
      }
    },
    
    pauseAutoSlide() {
      this.clearAutoSlide();
    },
    
    resumeAutoSlide() {
      this.resetAutoSlide();
    }
  }
}
</script>

<style scoped>
.w3-row-padding w3-padding-64 w3-theme-l1 {
  font-family: "Raleway", sans-serif;
}
</style>